<template>
  <div :id="personId">
    <v-card @click.stop="dialog = true" class="personCard">
      <v-img
        v-if="personPhoto && personImageUrl != null"
        contain
        class="personImage"
        :lazy-src="emptyPhoto"
        :src="personImageUrl"
      />
      <v-img v-else contain class="personImage" :src="emptyPhoto"/>
      <div class="personCardName">{{personName}}</div>
    </v-card>

    <v-dialog v-model="dialog" max-width="700">
      <v-card class="dialogFlex">
        <div class="dialogX" @click="dialog = false">
          <v-icon>close</v-icon>
        </div>
        <v-card-text>
          <v-layout column>
            <v-flex>
              <v-layout row>
                <v-flex xs4>
                  <!-- :src="emptyPhoto" -->
                  <v-img
                    class="dialogImage"
                    v-if="personPhoto && personImageUrl != null"
                    :lazy-src="emptyPhoto"
                    :src="personImageUrl"
                  />
                  <v-img v-else contain class="dialogImage" :src="emptyPhoto"/>
                </v-flex>
                <v-flex xs8>
                  <v-layout column style="margin-left: 20px">
                    <v-flex>
                      <span style="font-weight: 400; font-size: 2.04rem;">{{ personName }}</span>
                      <hr class="dialogHr">
                    </v-flex>

                    <v-layout>
                      <v-flex xs6>
                        <span class="dialogHeading">Date</span>
                        -
                        <font class="textFont">{{ dateIndianFormat }}</font>
                      </v-flex>
                      <v-flex xs6>
                        <span class="dialogHeading">Age</span>
                        -
                        <font class="textFont">{{ personAge }}</font>
                        <hr class="dialogHr">
                      </v-flex>
                    </v-layout>

                    <v-flex>
                      <span class="dialogHeading">Incident Location</span>
                      -
                      <div style="display: inline; font-size: 1.329rem; margin-left: 4px;">
                        <font class="textFont">{{ personIncidentLocation }}</font>
                      </div>
                      <hr class="dialogHr">
                    </v-flex>

                    <v-flex>
                      <span class="dialogHeading">Address</span>
                      -
                      <font
                        class="textFont"
                      >{{ personAddress }} , {{ personDistrict }}</font>
                      <hr class="dialogHr">
                    </v-flex>

                    <v-flex>
                      <span class="dialogHeading">Agency</span>
                      -
                      <font class="textFont">{{ personAgency }}</font>
                      <hr class="dialogHr">
                    </v-flex>
                    <v-flex>
                      <span class="dialogHeading">Classification</span>
                      -
                      <font class="textFont">{{ personClassification }}</font>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex>
              <v-layout column style="margin-top: 0px">
                <v-flex>
                  <hr style="transform: translateY(-4px)" class="dialogHr">
                  <span class="dialogHeading">Incident Report</span>:
                  <br>
                  <div class="dialogIncidentReport textFont">{{personIncidentReport}}</div>
                  <!-- <hr class="dialogHr"> -->
                </v-flex>
                <v-flex v-if="personStatus != null">
                  <span class="dialogHeading">Status</span>
                  :
                  <font class="textFont">{{personStatus}}</font>
                  <hr class="dialogHr">
                </v-flex>
                <v-flex>
                  <span class="dialogHeading">Sources:</span>
                  <div style="display: inline-block; margin-left: 0.5rem;">
                    <a class="dialogSourceATag textFont" @click="openNewsLink">{{personNewsSource}}</a>
                    &nbsp;
                    <a
                      class="dialogSourceATag textFont"
                      @click="openNewsLink2"
                    >{{personNewsSource2}}</a>
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-card-actions style="margin: 0 0 12px 9px;">
          <span class="dialogHeading">Share:</span>
          <v-btn icon style="transform: translateX(2px)">
            <a
              style="color: inherit;"
              :href="'whatsapp://send?text=' + personName + ' - https://souvenirsofconflict.com/\#' + personName"
              data-action="share/whatsapp/share"
            >
              <font-awesome-icon class="dialogSocialIcons" :icon="['fab', 'whatsapp']"></font-awesome-icon>
            </a>
          </v-btn>

          <v-btn icon>
            <a
              style="color: inherit;"
              :href="'https://www.facebook.com/sharer.php?u=' + 'https://souvenirsofconflict.com/#' + personName"
              target="_blank"
            >
              <font-awesome-icon class="dialogSocialIcons" :icon="['fab', 'facebook']"/>
            </a>
          </v-btn>
          <v-btn icon>
            <a
              style="color: inherit;"
              :href="'http://twitter.com/share?text=Souvenirs Of Conflict - '+ personName + ' -' + '&url=http://souvenirsofconflict.com/' + '&hashtags=souvenirsofconflict'"
              target="_blank"
            >
              <font-awesome-icon class="dialogSocialIcons" :icon="['fab', 'twitter']"/>
            </a>
          </v-btn>

          <!-- <v-btn icon @click="doCopy(personId)">
            <v-icon>link</v-icon>
          </v-btn>-->
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: [
    "personId",
    "personName",
    "personDistrict",
    "personGender",
    "personDate",
    "personIncidentLocation",
    "personAge",
    "personAddress",
    "personAgency",
    "personClassification",
    "personIncidentReport",
    "personStatus",
    "personSources",
    "personImageUrl",
    "personPhoto",
    "personNewsSource",
    "personNewsSourceLink",
    "personNewsSource2",
    "personNewsSource2Link"
  ],
  data() {
    return {
      dialog: false,
      emptyPhoto: require("../../assets/nophoto.jpeg"),
      testingCode: "1234"
    };
  },
  methods: {
    openNewsLink() {
      window.open(this.personNewsSourceLink, "_blank");
    },
    openNewsLink2() {
      window.open(this.personNewsSource2Link, "_blank");
    },
    doCopy(personId) {
      window.open("https://souvenirsofconflict.com/#" + personId, "_blank");
    }
  },
  computed: {
    dateIndianFormat() {
      let ourArray = this.personDate.split("/");
      return ourArray[2] + "/" + ourArray[1] + "/" + ourArray[0];
    }
  }
};
</script>

<style lang="stylus" scoped>
.textFont {
  font-family: 'Slabo 27px', serif;
}

.dialogFlex {
  margin: 0 1rem 1rem 0;
  font-size: 1.4rem;
  position: relative;
}

.dialogSourceATag {
  color: inherit;
  transition: color 0.3s ease;

  &:hover {
    color: #e53d3d;
    transition: color 0.3s ease;
  }
}

.dialogX {
  position: absolute;
  right: 0;
  top: 0;
  margin: 1rem;
  padding: 0.5rem;
  cursor: pointer;
  transition: background-color 0.2s ease-out;

  &:hover {
    background-color: #333333;
    transition: background-color 0.6s ease;
  }
}

.dialogSocialIcons {
  font-size: 1.4rem;
}

.dialogHr {
  margin: 6px 0;
  opacity: 0.1;
}

.dialogHeading {
  font-size: 20px;
  font-weight: 550;
  padding: 2px 4px;
  margin-right: 2px;
}

.dialogIncidentReport {
  margin-left: 4px;
}

.dialogImage {
  max-width: 20rem;
  max-height: 40rem;
  bottom: 0;
}

.personCard {
  margin: 1.5rem;
  position: relative;
}

.personImage {
  -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
  filter: grayscale(100%);
  transition: filter 0.6s ease;
  max-width: 20rem;
  max-height: 30rem;

  &:hover {
    -webkit-filter: grayscale(0%); /* Safari 6.0 - 9.0 */
    filter: grayscale(0%);
    transition: filter 0.5s ease;
  }
}

.personCardHelpText {
  position: relative;
}

.personCardName {
  position: absolute;
  bottom: 0rem;
  width: 100%;
  padding-left: 1rem;
  font-weight: 500;
  font-size: 1.34rem;
  background-color: rgba(#777777, 0.4);
  color: white;
}

.personClickedDialog {
  max-width: 10px;
  width: 10px;
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .personCardName {
    position: absolute;
    bottom: 0rem;
    width: 100%;
    padding-left: 1rem;
    font-weight: 500;
    font-size: 1.34rem;
    background-color: rgba(#777777, 0.4);
    color: white;
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .personCardName {
    position: absolute;
    bottom: 0rem;
    width: 100%;
    padding-left: 1rem;
    font-weight: 500;
    font-size: 1.34rem;
    background-color: rgba(#777777, 0.4);
    color: white;
  }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .personCardName {
    position: absolute;
    bottom: 0rem;
    width: 100%;
    padding-left: 1rem;
    font-weight: 500;
    font-size: 1.34rem;
    background-color: rgba(#777777, 0.4);
    color: white;
  }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .personCardName {
    position: absolute;
    bottom: 0rem;
    width: 100%;
    padding-left: 1rem;
    font-weight: 500;
    font-size: 1.34rem;
    background-color: rgba(#777777, 0.4);
    color: white;
  }
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1270px) {
  .personCardName {
    position: absolute;
    bottom: 0rem;
    width: 100%;
    padding-left: 1rem;
    font-weight: 500;
    font-size: 0.78rem;
    background-color: rgba(#777777, 0.4);
    color: white;
  }
}
@media only screen and (min-width: 1601px) {
  .personCardName {
    position: absolute;
    bottom: 0rem;
    width: 100%;
    padding-left: 1rem;
    font-weight: 500;
    font-size: 1.32rem;
    background-color: rgba(#777777, 0.4);
    color: white;
  }
}
</style>
